// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2teVq","legacyBtn":"MutateMid_legacyBtn__2hhIu"};